import { Checkbox } from 'antd';
import styled from 'styled-components';

export const ChooseUnitsContainerStyled = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ChooseUnitsSummaryStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const ChooseUnitsSummaryPriceStyled = styled.p`
	margin: 0;
	font-weight: 600;
	font-size: 24px;
`;

export const ChooseUnitsSelectionHeadingContainerStyled = styled.div`
	gap: 4px;
	display: flex;
	align-items: center;
`;

export const ChooseUnitsSummaryNameStyled = styled.p`
	margin: 0;
	font-weight: 400;
	font-size: 14px;
`;

export const PeriodContainerStyled = styled.div`
	margin: 16px 0;
`;

export const PaymentInfoContainerStyled = styled.div`
	margin: 16px 0;
`;

export const OrderInfoContainerStyled = styled.div`
	gap: 8px;
	display: flex;
	flex-direction: column;
	margin: 16px 0;
`;

export const OrderInfoItemStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const OrderInfoItemTextStyled = styled.p`
	margin: 0;
	font-weight: 400;
	font-style: normal;
	font-size: 16px;
`;

export const PriceSummaryContainerStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 16px;
`;

export const TermsOfServiceContainerStyled = styled.div`
	gap: 8px;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 16px 0;
`;

export const ChooseUnitsSelectedContainerStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`;

export const PriceSummaryHeadingStyled = styled.h2`
	margin: 0;
	color: #262626;
	letter-spacing: 0.38px;
	font-weight: 600;
	font-style: normal;
	font-size: 20px;
	line-height: 28px;
`;

export const ChooseUnitsTextStyled = styled.p`
	margin: 0;
	color: #262626;
	letter-spacing: -0.15px;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
`;

export const ChooseUnitsSummaryResultStyled = styled.p`
	margin: 0;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 14px;
`;

export const ChooseUnitsSummaryHeadingStyled = styled.h3`
	margin-bottom: 16px;
	font-size: 16px;
`;

export const ChooseUnitsSelectionHeadingStyled = styled.h3`
	margin-bottom: 12px;
	font-weight: 600;
	font-size: 20px;
`;
export const ChooseUnitsSelectedStyled = styled.p`
	margin: 0;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 14px;
`;

export const OldUsersContainerStyled = styled.div`
	margin: 8px 0 24px 0;
	padding: 16px 24px;
	border: 1px solid #91d5ff;
	border-radius: 8px;
	background-color: #e6f7ff;
`;

export const GridCheckboxGroupStyled = styled(Checkbox.Group)`
	row-gap: 4px;
	grid-template-columns: 1fr 1fr 1fr;
	display: grid;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		grid-template-columns: 1fr 1fr;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		grid-template-columns: 1fr 1fr 1fr;
	}
	@media (min-width: ${props => props.theme.breakpoints.md}) {
		grid-template-columns: 1fr 1fr 1fr;
	}
	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		grid-template-columns: 1fr 1fr 1fr;
	}
	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		grid-template-columns: 1fr 1fr 1fr;
	}
	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		grid-template-columns: 1fr 1fr 1fr;
	}
`;

export const TrialDescriptionContainerStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 24px 0;
	padding: 16px 24px;
	width: 100%;
	border: 1px solid #f5f5f5;
	border-radius: 8px;
	background-color: #fafafa;
`;

export const BlockContainerStyled = styled.div`
	margin: 24px 0;
`;

export const ChooseUnitsPriceContainerStyled = styled.div`
	gap: 5px;
	display: flex;
	align-items: center;
`;

export const FixedPriceContainerStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
`;

export const AdditionalPriceStyled = styled.p`
	margin-bottom: 0;
	width: fit-content;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 12px;
`;
